// extracted by mini-css-extract-plugin
module.exports = {"Page":"Page_Page__aPuy3","Title":"Page_Title__F_QfA"};